import './ResultsNotFound.css';

function ResultsNotFound() {
	return <h2 className="ResultsNotFound">No countries found :(</h2>;
}

export { ResultsNotFound };
